module.exports = __webpack_public_path__ + "static/img/lifestyle_27.5cd15ef8.jpg";